import { useMemo } from 'react';
import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { GET_MEASUREMENTS_AND_CALCULATED_DIMENSIONS } from './gql';

export const useCalcDims = (options?) => {
  const queryResult = useGqlQuery<{
    findMeasurementsByAccountId: { measurement; createdByUserId; updatedByUserId; id }[];
    findCalculatedDimensionsByAccountId: { calculatedDimension; createdByUserId; updatedByUserId; id }[];
  }>({
    queryKey: [QueryKey.MeasurementsAndCalculatedDimensions],
    query: GET_MEASUREMENTS_AND_CALCULATED_DIMENSIONS,
    select: (_, data) => data,
    ...options,
  });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return { all: [], visible: [], asObject: {} };
    }

    const calculatedDimensionsData = queryResult.data.findCalculatedDimensionsByAccountId || [];

    const calculatedDimensionsAll = calculatedDimensionsData.map(v => {
      const { calculatedDimension, ...rest } = v;
      return {
        ...calculatedDimension,
        ...rest,
        // Handle the nested type structure for calculated dimensions
        type: calculatedDimension.type?.kindWrapper?.kind || calculatedDimension.type,
        createdByUserId: v.createdByUserId,
        updatedByUserId: v.updatedByUserId,
        id: v.id,
      };
    });

    return {
      all: calculatedDimensionsAll,
      visible: calculatedDimensionsAll.filter(({ hidden }) => !hidden),
      asObject: calculatedDimensionsAll.reduce((acc, item) => {
        const { systemName, ...rest } = item;
        acc[systemName] = rest;
        return acc;
      }, {}),
    };
  }, [queryResult.data]);

  return { ...queryResult, data };
};
